var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetaDefenderAccessIt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 203.27 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#050f22;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Product"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.04,47.54h1.72v15.67h-1.7v-12.04l-3.74,7.83h-1.61l-3.74-7.83v12.04h-1.7v-15.67h1.72l4.52,9.49,4.52-9.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.22,59.58h1.72c-.29,2.89-2.48,3.85-4.5,3.85-2.15,0-4.52-1.12-4.52-4.52v-3.04c0-3.4,2.37-4.52,4.52-4.52s4.52,1.12,4.52,4.52v1.95h-7.36v1.12c0,1.92,1.34,2.89,2.84,2.89,1.32,0,2.51-.74,2.78-2.24ZM26.28,55.85c0-1.92-1.34-2.89-2.84-2.89s-2.84.96-2.84,2.89v.43h5.69v-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.11,60.59c0,.74.27,1.01,1.07,1.01h1.77v1.61h-1.77c-2.15,0-2.75-.78-2.75-2.75v-7.19h-1.63v-1.61h1.63v-2.62h1.68v2.62h2.84v1.61h-2.84v7.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.83,55.2h-1.72c.29-2.89,2.49-3.85,4.5-3.85,2.15,0,4.52,1.12,4.52,4.52v7.34h-1.68v-1.19c-.74.96-2.04,1.41-3.6,1.41-1.97,0-3.83-1.05-3.83-3.42,0-1.16.49-2.73,2.51-3.31,1.32-.38,2.98-.51,4.93-.65v-.2c0-1.92-1.34-2.89-2.84-2.89-1.32,0-2.51.74-2.78,2.24ZM45.45,57.55c-2.53.18-3.96.34-4.75.76-.85.47-1.01.98-1.01,1.66,0,1.05.81,1.86,2.51,1.86,1.81,0,3.25-.96,3.25-2.78v-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.5,47.54c3,0,5.06,2.01,5.06,5.31v5.06c0,3.29-2.06,5.31-5.06,5.31h-5.06v-15.67h5.06ZM52.16,49.24v12.27h3.33c1.86,0,3.34-1.23,3.34-3.6v-5.06c0-2.37-1.48-3.58-3.34-3.6h-3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.54,59.58h1.72c-.29,2.89-2.48,3.85-4.5,3.85-2.15,0-4.52-1.12-4.52-4.52v-3.04c0-3.4,2.37-4.52,4.52-4.52s4.52,1.12,4.52,4.52v1.95h-7.37v1.12c0,1.92,1.34,2.89,2.84,2.89,1.32,0,2.51-.74,2.78-2.24ZM70.61,55.85c0-1.92-1.34-2.89-2.84-2.89s-2.84.96-2.84,2.89v.43h5.69v-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.56,49.15c-.81,0-1.08.27-1.08,1.01v1.5h2.84v1.61h-2.84v9.94h-1.68v-9.94h-1.63v-1.61h1.63v-1.37c0-1.97.6-2.75,2.75-2.75h1.77v1.61h-1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.15,59.58h1.72c-.29,2.89-2.48,3.85-4.5,3.85-2.15,0-4.52-1.12-4.52-4.52v-3.04c0-3.4,2.37-4.52,4.52-4.52s4.52,1.12,4.52,4.52v1.95h-7.37v1.12c0,1.92,1.34,2.89,2.84,2.89,1.32,0,2.51-.74,2.78-2.24ZM89.21,55.85c0-1.92-1.34-2.89-2.84-2.89s-2.84.96-2.84,2.89v.43h5.69v-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.87,55.87v7.34h-1.68v-7.36c0-1.92-1.34-2.89-2.84-2.89s-2.84.96-2.84,2.89v7.36h-1.68v-11.55h1.68v1.1c.58-.94,1.79-1.41,2.84-1.41,2.15,0,4.52,1.12,4.52,4.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.76,58.91v-3.04c0-3.4,2.37-4.52,4.52-4.52,1.05,0,2.26.47,2.84,1.41v-5.22h1.68v15.67h-1.68v-1.19c-.58.94-1.79,1.41-2.84,1.41-2.15,0-4.52-1.12-4.52-4.52ZM107.44,58.94c0,1.92,1.34,2.89,2.84,2.89s2.84-.96,2.84-2.89v-3.09c0-1.92-1.34-2.89-2.84-2.89s-2.84.96-2.84,2.89v3.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.14,59.58h1.72c-.29,2.89-2.49,3.85-4.5,3.85-2.15,0-4.52-1.12-4.52-4.52v-3.04c0-3.4,2.37-4.52,4.52-4.52s4.52,1.12,4.52,4.52v1.95h-7.36v1.12c0,1.92,1.34,2.89,2.84,2.89,1.32,0,2.51-.74,2.78-2.24ZM125.21,55.85c0-1.92-1.34-2.89-2.84-2.89s-2.84.96-2.84,2.89v.43h5.69v-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.5,52.87c.58-.94,1.79-1.41,2.84-1.41h.74v1.61h-.74c-1.5,0-2.84.96-2.84,2.89v7.25h-1.68v-11.55h1.68v1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.27,75.99h1.72v15.67h-1.72v-15.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.1,77.69v-1.7h10.09v1.7h-4.19v13.97h-1.72v-13.97h-4.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.72,87.25h-5.69l-1.43,4.41h-1.75l5.04-15.67h1.97l5.04,15.67h-1.75l-1.43-4.41ZM28.88,78.38l-2.33,7.27h4.66l-2.33-7.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.4,83.75h-1.7c-.22-1.57-1.45-2.35-2.8-2.35-1.5,0-2.84.96-2.84,2.89v3.09c0,1.92,1.34,2.89,2.84,2.89,1.34,0,2.57-.78,2.8-2.35h1.7c-.25,2.98-2.46,3.96-4.5,3.96-2.15,0-4.52-1.1-4.52-4.52v-3.04c0-3.4,2.37-4.52,4.52-4.52,2.04,0,4.25.98,4.5,3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.93,83.75h-1.7c-.22-1.57-1.45-2.35-2.8-2.35-1.5,0-2.84.96-2.84,2.89v3.09c0,1.92,1.34,2.89,2.84,2.89,1.34,0,2.57-.78,2.8-2.35h1.7c-.25,2.98-2.46,3.96-4.5,3.96-2.15,0-4.52-1.1-4.52-4.52v-3.04c0-3.4,2.37-4.52,4.52-4.52,2.04,0,4.25.98,4.5,3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.74,88.03h1.72c-.29,2.89-2.49,3.85-4.5,3.85-2.15,0-4.52-1.12-4.52-4.52v-3.04c0-3.4,2.37-4.52,4.52-4.52s4.52,1.12,4.52,4.52v1.95h-7.36v1.12c0,1.92,1.34,2.89,2.84,2.89,1.32,0,2.51-.74,2.78-2.24ZM66.8,84.29c0-1.92-1.34-2.89-2.84-2.89s-2.84.96-2.84,2.89v.43h5.69v-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.3,83.48c-.2-1.34-1.1-2.08-2.53-2.08-1.25,0-2.17.63-2.17,1.68,0,.96.65,1.39,1.59,1.61l2.17.54c1.75.43,2.96,1.3,2.96,3.42,0,2.28-1.72,3.22-4.07,3.22s-4.45-1.12-4.63-3.92h1.72c.16,1.63,1.37,2.31,2.91,2.31s2.35-.65,2.37-1.66c0-.74-.34-1.39-1.61-1.7l-2.26-.56c-1.25-.29-2.84-1.14-2.84-3.2s1.77-3.36,3.89-3.36c2.33,0,4.05,1.12,4.23,3.69h-1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.67,83.48c-.2-1.34-1.1-2.08-2.53-2.08-1.25,0-2.17.63-2.17,1.68,0,.96.65,1.39,1.59,1.61l2.17.54c1.75.43,2.96,1.3,2.96,3.42,0,2.28-1.72,3.22-4.07,3.22s-4.45-1.12-4.63-3.92h1.72c.16,1.63,1.37,2.31,2.91,2.31s2.35-.65,2.37-1.66c0-.74-.34-1.39-1.61-1.7l-2.26-.56c-1.25-.29-2.84-1.14-2.84-3.2s1.77-3.36,3.89-3.36c2.33,0,4.05,1.12,4.23,3.69h-1.72Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Wordmark"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.74,0c-3.82,0-7.23,1.29-9.71,3.41v4.23c2.12-2.3,5.57-4.33,9.76-4.33,6.81,0,12.06,5.34,12.06,12.52v9.9c2.26-2.39,3.68-5.85,3.68-9.9C31.53,6.72,24.49,0,15.74,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.73,15.56V5.66C1.47,8.06,0,11.51,0,15.56c0,9.11,7.04,15.83,15.79,15.83,3.82,0,7.23-1.29,9.76-3.41v-4.24c-2.16,2.3-5.66,4.33-9.8,4.33-6.81,0-12.01-5.39-12.01-12.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.77.51h-10.68v30.38h3.59V3.64h7.04c4,0,6.08,2.49,6.08,5.71s-2.07,5.66-6.08,5.66h-4.79v3.13h4.83c5.98,0,9.71-3.68,9.71-8.84S58.76.51,52.77.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.22,7.14l2.62-1.98c-1.84-2.95-5.34-5.16-9.39-5.16-1.2,0-2.3.18-3.31.51v3.41c1.01-.41,2.21-.6,3.22-.6,2.76,0,5.25,1.38,6.86,3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.13,14.45l-3.36-1.61c-2.76-1.33-4.88-2.35-4.88-5.57V1.57c-2.21,1.33-3.73,3.54-3.73,6.4,0,4.28,3.31,6.4,6.86,8.1l3.41,1.61c2.99,1.43,5.06,2.53,5.06,5.8v6.21c2.3-1.47,3.73-3.77,3.73-6.77,0-4.1-2.62-6.35-7.09-8.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.89,22.88l-2.67,1.98c2.35,4,6.4,6.54,11.09,6.54,1.43,0,2.72-.23,3.91-.64v-3.36c-1.2.41-2.58.69-3.87.69-3.91,0-6.63-2.39-8.47-5.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "98.22 .56 109.77 31.44 111.06 31.44 112.35 28.31 102.18 .56 98.22 .56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "131.96 20.53 133.89 25.28 143.1 .56 139.19 .56 131.96 20.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "120.04 .05 111.89 20.44 113.59 25.14 120.68 7.37 130.3 31.44 131.64 31.44 132.69 28.5 121.32 .05 120.04 .05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "154.06 21.55 158.89 10.32 157.01 5.85 146.33 30.94 150.1 30.94 152.68 24.77 165.11 24.77 163.73 21.55 154.06 21.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "159.49 .05 158.2 2.95 170.17 30.94 173.99 30.94 160.83 .05 159.49 .05"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 175.88,
    y: 0.56,
    width: 25,
    height: 3.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 186.56,
    y: 6.03,
    width: 3.59,
    height: 24.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.91,26.76c-1.3,0-2.38,1.09-2.38,2.43s1.08,2.42,2.38,2.42,2.36-1.09,2.36-2.42-1.06-2.43-2.36-2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.91,26.76c-1.3,0-2.38,1.09-2.38,2.43s1.08,2.42,2.38,2.42,2.36-1.09,2.36-2.42-1.06-2.43-2.36-2.43Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaDefenderAccessIt);
export default __webpack_public_path__ + "static/media/MetaDefender_Access-IT.ab8d6babf88c24899593222dfdb638a2.svg";
export { ForwardRef as ReactComponent };